// extracted by mini-css-extract-plugin
module.exports = {"report_hesitation":"index_report_hesitation__1VInQ","hesitation__label":"index_hesitation__label__29TD0","hesitation__unit":"index_hesitation__unit__3ms_7"};